var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheEliteLaserFacial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.4844,
    r: 24,
    fill: "#A0CFDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 10.4844V23.2934V10.4844Z",
    fill: "#0F2A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10.4844V23.2934",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29.8691V38.4837V29.8691Z",
    fill: "#0F2A59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29.8691V38.4837",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9993 24.4844H29.3848H37.9993Z",
    fill: "#0F2A59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9993 24.4844H29.3848",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6145 24.4844H10H18.6145Z",
    fill: "#0F2A59"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6145 24.4844H10",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8984 14.5859L27.8066 20.6777L33.8984 14.5859Z",
    fill: "#0F2A59"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8984 14.5859L27.8066 20.6777",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1934 28.291L14.1016 34.3828L20.1934 28.291Z",
    fill: "#0F2A59"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1934 28.291L14.1016 34.3828",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8984 34.3828L27.8066 28.291L33.8984 34.3828Z",
    fill: "#0F2A59"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8984 34.3828L27.8066 28.291",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1934 20.6777L14.1016 14.5859L20.1934 20.6777Z",
    fill: "#0F2A59"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1934 20.6777L14.1016 14.5859",
    stroke: "#0F2A59",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23.8682C24.7683 23.8683 25.3916 24.4914 25.3916 25.2598C25.3914 26.028 24.7682 26.6512 24 26.6514C23.2316 26.6514 22.6086 26.0281 22.6084 25.2598C22.6084 24.4913 23.2315 23.8682 24 23.8682Z",
    fill: "#0F2A59",
    stroke: "#0F2A59",
    strokeWidth: 1.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheEliteLaserFacial);
export default __webpack_public_path__ + "static/media/the-elite-laser-facial.52ae8220c76e59859994dd6af0c555b3.svg";
export { ForwardRef as ReactComponent };